<ng-container *ngIf="!dynamicallyLoaded">
    <ng-container [ngSwitch]="facet?.FacetName | lowercase">
        <animal-facet *ngSwitchCase="'animals'" [facetId]="facetId" [facet]="facet"></animal-facet>
        <audit-facet *ngSwitchCase="'audit'" [facetId]="facetId" [facet]="facet"></audit-facet>
        <birth-facet *ngSwitchCase="'births'" [facetId]="facetId" [facet]="facet"></birth-facet>
        <characteristics-facet *ngSwitchCase="'characteristics'" [facetId]="facetId" [facet]="facet"></characteristics-facet>
        <charts-facet *ngSwitchCase="'charts'" [facetId]="facetId" [facet]="facet"></charts-facet>
        <clinical-facet *ngSwitchCase="'clinical'" [facetId]="facetId" [facet]="facet"></clinical-facet>
        <construct-facet *ngSwitchCase="'constructs'" [facetId]="facetId" [facet]="facet"></construct-facet>
        <!-- <cohort-facet *ngSwitchCase="'cohorts'" [facetId]="facetId" [facet]="facet"></cohort-facet> -->
        <device-management-facet *ngSwitchCase="'devices'" [facetId]="facetId" [facet]="facet"></device-management-facet>
        <enumerations-facet *ngSwitchCase="'enumerations'" [facetId]="facetId" [facet]="facet"></enumerations-facet>
        <genotype-facet *ngSwitchCase="'genotypes'" [facetId]="facetId" [facet]="facet"></genotype-facet>
        <housing-facet *ngSwitchCase="'housing'" [facetId]="facetId" [facet]="facet"></housing-facet>
        <import-facet *ngSwitchCase="'import'" [facetId]="facetId" [facet]="facet"></import-facet>
        <institution-facet *ngSwitchCase="'institutions'" [facetId]="facetId" [facet]="facet"></institution-facet>
        <iot-alert-definition-facet *ngSwitchCase="'iot alerts'" [facetId]="facetId" [facet]="facet"></iot-alert-definition-facet>
        <iot-plots-facet *ngSwitchCase="'iot plots'" [facetId]="facetId" [facet]="facet"></iot-plots-facet>
        <!-- <job-facet *ngSwitchCase="'jobs'" [facetId]="facetId" [facet]="facet"></job-facet> -->
        <!-- <job-pharma-facet *ngSwitchCase="'jobs pharma'" [facetId]="facetId" [facet]="facet"></job-pharma-facet> -->
        <line-facet *ngSwitchCase="'lines'" [facetId]="facetId" [facet]="facet"></line-facet>
        <location-facet *ngSwitchCase="'locations'" [facetId]="facetId" [facet]="facet"></location-facet>
        <mating-facet *ngSwitchCase="'matings'" [facetId]="facetId" [facet]="facet"></mating-facet>
        <monitoring-facet *ngSwitchCase="'monitoring'" [facetId]="facetId" [facet]="facet"></monitoring-facet>
        <!-- <order-facet *ngSwitchCase="'orders'" [facetId]="facetId" [facet]="facet"></order-facet> -->
        <plate-facet *ngSwitchCase="'plates'" [facetId]="facetId" [facet]="facet"></plate-facet>
        <protocol-facet *ngSwitchCase="'protocols'" [facetId]="facetId" [facet]="facet"></protocol-facet>
        <reporting-facet *ngSwitchCase="'reporting'" [facetId]="facetId" [facet]="facet"></reporting-facet>
        <!-- <resource-facet *ngSwitchCase="'resources'" [facetId]="facetId" [facet]="facet">></resource-facet> -->
        <roles-facet *ngSwitchCase="'roles'" [facetId]="facetId" [facet]="facet"></roles-facet>
        <sample-facet *ngSwitchCase="'samples'" [facetId]="facetId" [facet]="facet"></sample-facet>
        <!-- <schedule-facet *ngSwitchCase="'schedule'" [facetId]="facetId" [facet]="facet"></schedule-facet> -->
        <search-facet *ngSwitchCase="'search'" [facetId]="facetId" [facet]="facet"></search-facet>
        <settings-facet *ngSwitchCase="'settings'" [facetId]="facetId" [facet]="facet"></settings-facet>
        <study-facet *ngSwitchCase="'studies'" [facetId]="facetId" [facet]="facet"></study-facet>
        <task-facet *ngSwitchCase="'tasks'" [facetId]="facetId" [facet]="facet"></task-facet>
        <users-facet *ngSwitchCase="'users'" [facetId]="facetId" [facet]="facet"></users-facet>
        <vocabularies-facet *ngSwitchCase="'vocabularies'" [facetId]="facetId" [facet]="facet"></vocabularies-facet>
        <workflow-facet *ngSwitchCase="'workflows'" [facetId]="facetId" [facet]="facet"></workflow-facet>
        <census-facet *ngSwitchCase="'census'" [facetId]="facetId" [facet]="facet"></census-facet>
        <permits-facet *ngSwitchCase="'permits'" [facetId]="facetId" [facet]="facet"></permits-facet>


        <div *ngSwitchDefault>
            <!-- If given facet type is not configured in this app -->
            <div class="facet">
                <facet-header [caption]="facet?.FacetName"
                    [facetId]="facetId">
                </facet-header>
                <div class="facet-body">
                    Unconfigured Facet Type: {{facet?.FacetName}}
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-container *ngIf="dynamicallyLoaded">
    <div #facetOutlet></div>
</ng-container>
